import { useEffect } from "react";
import chainConfig from "../chainConfig";
import keplr from "../images/keplr.png";
import FromToBox from "./FromToBox";

const { chainId } = chainConfig;

const KeplrFromToBox = ({
  title = "",
  chain,
  setFrom = () => { },
  from,
  to,
  setTo = () => { },
  loading,
  setLoading,
  balance,
  setBalance,
  estimateGas,
  setEstimateGas,
  connected,
  setConnected,
  account,
  setAccount,
  disabled,
  alert,
  setAlert,
  inputDisabled,
  canFetch = false,
  setCanFetch = () => { },
  useCustomToAddress,
  setUseCustomToAddress,
  customToAddress,
  setCustomToAddress,
  autoConnectWallet,
  setAutoConnectWallet,
  connectOptions,
  onChangeChain,
}) => {
  useEffect(() => {
    if (autoConnectWallet === 'protocol') {
      setAutoConnectWallet(null);
      connectWallet();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoConnectWallet, setAutoConnectWallet]);
  useEffect(() => {
    if (connected && canFetch && !disabled) {
      getBalance();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [connected, canFetch, disabled]);

  useEffect(() => {
    const cosmosAddressRegex = /^6x[a-z0-9]{38,}$/;
    if (disabled && customToAddress && cosmosAddressRegex.test(customToAddress)) {
      const fetchCustomBalance = async () => {
        setLoading(true);
        try {
          const res = await fetch(`${chainConfig.rest}/cosmos/bank/v1beta1/balances/${customToAddress}`);
          const data = await res.json();
          const coin = data.balances?.find(b => b.denom === chainConfig.currencies[0].coinMinimalDenom);
          const amount = coin ? coin.amount : 0;
          const realAmount = amount / 10 ** chainConfig.currencies[0].coinDecimals;
          setBalance(realAmount);
        } catch (error) {
          console.error(error);
          setBalance(0);
        } finally {
          setLoading(false);
        }
      };
      fetchCustomBalance();
    } else if (disabled) {
      setBalance(0);
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabled, customToAddress, setBalance]);

  const connectWallet = async () => {
    if (!window.keplr) {
      alert("Please install Keplr extension");
      return;
    }
    setLoading(true);
    try {
      await window.keplr.experimentalSuggestChain(chainConfig);

      await window.keplr.enable(chainId);
      const address = await window.keplr.getKey(chainId);
      setAccount(address.bech32Address);
      setConnected(true);
      setCanFetch(true);
      setAlert(null)
    } catch (error) {
      setLoading(false);
      console.error("Failed to connect wallet:", error);
    }
  };

  const disconnectWallet = () => {
    setLoading(true);
    setConnected(false);
    setBalance(null);
    setAccount(null);
    setLoading(false);
    setEstimateGas(null);
  };

  const getBalance = async () => {
    try {
      const keyInfo = await window.keplr.getKey(chainId);
      const { bech32Address } = keyInfo;

      const res = await fetch(`${chainConfig.rest}/cosmos/bank/v1beta1/balances/${bech32Address}`);
      const data = await res.json();
      const coin = data.balances?.find(b => b.denom === chainConfig.currencies[0].coinMinimalDenom);
      const amount = coin ? coin.amount : 0;
      const realAmount = Number(amount) / 10 ** chainConfig.currencies[0].coinDecimals;
      const realGas = 625000 / 10 ** chainConfig.currencies[0].coinDecimals;

      setEstimateGas(realGas);
      setBalance(realAmount);
      setCanFetch(false);
    } catch (error) {
      console.error("Failed to get balance:", error);
    } finally {
      setLoading(false);
    }
  };


  return (
    <FromToBox
      title={title}
      connected={connected}
      connectIcon={keplr}
      onConnect={connectWallet}
      address={account}
      balance={balance}
      chain={chain}
      isLoading={loading}
      setFrom={setFrom}
      from={from}
      to={to}
      setTo={setTo}
      disabled={disabled}
      alert={alert}
      inputDisabled={inputDisabled}
      onDisconnect={disconnectWallet}
      estimateGas={estimateGas}
      useCustomToAddress={useCustomToAddress}
      setUseCustomToAddress={setUseCustomToAddress}
      customToAddress={customToAddress}
      setCustomToAddress={setCustomToAddress}
      connectOptions={connectOptions}
      onChangeChain={onChangeChain}
    />
  );
};

export default KeplrFromToBox;
